module.exports = __webpack_public_path__ + "media/images/icons/Strakonice_web_ikony/stavyToku-9d0af3532c474fbb6d6f160c08307077.png";